(function () {
  "use strict";

  angular
    .module('trainerWebApp.directives')
    .constant('mfUploadSettings', {
      flash_url: "scripts/vendor/swfupload.swf",
      //upload_url: Set in fileDialogComplete after file is selected
      file_size_limit: mfConfig.upload.fileSizeLimit,
      file_types: mfConfig.upload.fileTypes,
      file_types_description: mfConfig.upload.fileTypesDescription,
      file_upload_limit: 0, //User can retry upload
      file_queue_limit: 1,
      debug: false,

      // Button Settings
      button_window_mode: SWFUpload.WINDOW_MODE.TRANSPARENT,
      button_cursor: SWFUpload.CURSOR.HAND,
      button_action: SWFUpload.BUTTON_ACTION.SELECT_FILE,

      // SWFObject settings
      minimum_flash_version: mfConfig.MinimumFlashVersionRequired
    })

    .controller('MfUploadCtrl', ['$scope', 'mfUploadSettings', '$attrs', '$modal', '$parse', 'uploadService', 'modalHelper', function ($scope, mfUploadSettings, $attrs, $modal, $parse, uploadService, modalHelper) {
      function fileQueueError(file, errorCode, message) {
        var title, buttons;
        switch (errorCode) {
          case SWFUpload.QUEUE_ERROR.FILE_EXCEEDS_SIZE_LIMIT:
            title = 'Unsupported File Size';
            message = "Mindflash can't upload this file because it exceeds the maximum file size. Files may not exceed " + settings.file_size_limit;
            buttons = [{label: 'OK'}];

          case SWFUpload.QUEUE_ERROR.ZERO_BYTE_FILE:
            title = 'Empty File';
            message = 'The file you are trying to upload is invalid. Please try uploading a different file.';
            buttons = [{label: 'OK'}];
          default:
            title = 'File Type Not Supported';
            message = "Mindflash can't upload this file because it is an unsupported file type.\n\nYou can upload the following file types: " + settings.file_types_description;
            buttons = [{label: 'OK'}];
        }
        modalHelper.messageBox({title: title, message: message, buttons: buttons}).result;
      }

      function onFileDialogComplete(numFilesSelected, numFilesQueued) {
        if (numFilesQueued > 0) {
          this.startUpload();
          isUploading = true;
          onStatusChange('uploading', 0);
        }
      }

      function onUploadStart(file) {
      }

      function onUploadProgress(file, bytesLoaded, bytesTotal) {
        if (!isUploading) return;
        var percent = Math.round(bytesLoaded / bytesTotal * 100);
        onStatusChange('uploading', percent);
      }

      function onUploadSuccess(file, result) {
        result = JSON.parse(result);    //SwfUpload doesn't help you here either

        isUploading = false;

        if (result.error) {
          onStatusChange('processingError', result);

          return modalHelper.messageBox({
            title: 'Error Processing Excel',
            message: result.error,
            buttons: [{label: 'OK'}]
          }).result;
        }

        onStatusChange('processing', result);
        uploadService.getParsedUpload(result.token, onParsedUpload);
      }

      function onUploadError(file, errorCode, message) {
        isUploading = false;
        onStatusChange('uploadFail', message, errorCode);
      }

      function onParsedUpload(result) {
        onStatusChange('success', result);
      }

      function wrapScope(fn) {
        return function () {
          fn.apply(this, arguments);

          if (!$scope.$root.$$phase)
            $scope.$apply();
        };
      }

      var settings = $scope.settings = _.extend({}, mfUploadSettings);  //Make a copy, editing constants is bad for your health

      var isUploading = false;
      var onStatusChange = angular.noop;
      if ($attrs.mfUploadStatusChange)
        onStatusChange = $parse($attrs.mfUploadStatusChange)($scope);

      _.extend(settings, {
        file_queue_error_handler: wrapScope(fileQueueError),
        file_dialog_complete_handler: wrapScope(onFileDialogComplete),
        upload_start_handler: wrapScope(onUploadStart),
        upload_progress_handler: wrapScope(onUploadProgress),
        upload_error_handler: wrapScope(onUploadError),
        upload_success_handler: wrapScope(onUploadSuccess)
      });

    }])

    .directive('mfUpload', ['$parse', function ($parse) {
      return {
        controller: 'MfUploadCtrl',
        link: function ($scope, elem, attrs, ctrl) {
          var rawElem = elem[0];

          var settings = $scope.settings;
          _.extend(settings, {
              button_placeholder: rawElem,
              button_width: elem.width(),
              button_height: elem.height()
            },
            $parse(attrs.mfUpload)($scope)
          );

          if (!settings.upload_url) throw Error('upload_url must be set!');

          var swfu = new SWFUpload(settings);

          $scope.$on('$destroy', function () {
            swfu.destroy();
          });

        }
      };
    }]);

})();
